







import Vue from 'vue'
import { mdiRefresh } from '@mdi/js'
import { ROUTES } from '@/enums'
import { Location } from 'vue-router'

export default Vue.extend({
    name: 'BtnTryAgain',

    props: {
        orderCode: {
            type: String,
            required: true,
        },
    },

    data: () => ({ mdiRefresh }),

    computed: {
        to(): Location {
            return { name: ROUTES.ORDER_DETAILS, params: { orderCode: this.orderCode } }
        },
    },
})
